// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BasePanel-module__container___bwZoT {
    position: relative;
    display: inline-block;
}

.BasePanel-module__backgroundImage___nODjX {
    display: block;
    width: 100%;
    height: auto;
}

.BasePanel-module__overlayImage___q1WOS,
.BasePanel-module__overlayVideo___Z6DAN {
    display: block;
}

@keyframes BasePanel-module__spin___Kzoz8 {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}

.BasePanel-module__spinner___WD4OZ {
    border: 4px solid rgba(0, 0, 0, 0.1);
    border-left: 4px solid #000;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    animation: BasePanel-module__spin___Kzoz8 1s linear infinite;
}

.BasePanel-module__spinnerContainer___goIKk {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.9);
}

.BasePanel-module__pdfCanvas___O8BtE {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.BasePanel-module__pdfFrame___xnnmH {
    width: 100%;
    height: 100%;
    border: none;
}

.BasePanel-module__pdfLoading___zLUO9 {
    width: 100%;
    height: 600px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f5f5f5;
    color: #666;
    font-size: 16px;
}

.BasePanel-module__pdfFallback___a6HVi {
    width: 100%;
    height: 600px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #f5f5f5;
    color: #666;
    font-size: 16px;
    gap: 20px;
}

.BasePanel-module__downloadButton___XXHBj {
    background-color: #007bff;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 16px;
    transition: background-color 0.3s;
}

    .BasePanel-module__downloadButton___XXHBj:hover {
        background-color: #0056b3;
    }

.BasePanel-module__previousButton___KSbFR,
.BasePanel-module__nextButton___dk0Eq {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background-color: rgba(0, 0, 0, 0.3);
    border: none;
    color: white;
    font-size: 24px;
    padding: 10px;
    cursor: pointer;
    border-radius: 50%;
    z-index: 10;
    transition: background-color 0.3s;
}

.BasePanel-module__previousButton___KSbFR {
    left: 10px;
}

.BasePanel-module__nextButton___dk0Eq {
    right: 10px;
}

    .BasePanel-module__previousButton___KSbFR:hover,
    .BasePanel-module__nextButton___dk0Eq:hover {
        background-color: rgba(0, 0, 0, 0.6);
    }
`, "",{"version":3,"sources":["webpack://./app/components/ProofOfDeliveryLayout/Panels/BasePanel/BasePanel.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;AAChB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,oCAAoC;IACpC,2BAA2B;IAC3B,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,4DAAkC;AACtC;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oCAAoC;AACxC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,iCAAiC;AACrC;;IAEI;QACI,yBAAyB;IAC7B;;AAEJ;;IAEI,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,oCAAoC;IACpC,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,aAAa;IACb,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,iCAAiC;AACrC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;IAEI;;QAEI,oCAAoC;IACxC","sourcesContent":[".container {\n    position: relative;\n    display: inline-block;\n}\n\n.backgroundImage {\n    display: block;\n    width: 100%;\n    height: auto;\n}\n\n.overlayImage,\n.overlayVideo {\n    display: block;\n}\n\n@keyframes spin {\n    from {\n        transform: rotate(0deg);\n    }\n\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n.spinner {\n    border: 4px solid rgba(0, 0, 0, 0.1);\n    border-left: 4px solid #000;\n    border-radius: 50%;\n    width: 40px;\n    height: 40px;\n    animation: spin 1s linear infinite;\n}\n\n.spinnerContainer {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: rgba(255, 255, 255, 0.9);\n}\n\n.pdfCanvas {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.pdfFrame {\n    width: 100%;\n    height: 100%;\n    border: none;\n}\n\n.pdfLoading {\n    width: 100%;\n    height: 600px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: #f5f5f5;\n    color: #666;\n    font-size: 16px;\n}\n\n.pdfFallback {\n    width: 100%;\n    height: 600px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    background: #f5f5f5;\n    color: #666;\n    font-size: 16px;\n    gap: 20px;\n}\n\n.downloadButton {\n    background-color: #007bff;\n    color: white;\n    border: none;\n    padding: 10px 20px;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 16px;\n    transition: background-color 0.3s;\n}\n\n    .downloadButton:hover {\n        background-color: #0056b3;\n    }\n\n.previousButton,\n.nextButton {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    background-color: rgba(0, 0, 0, 0.3);\n    border: none;\n    color: white;\n    font-size: 24px;\n    padding: 10px;\n    cursor: pointer;\n    border-radius: 50%;\n    z-index: 10;\n    transition: background-color 0.3s;\n}\n\n.previousButton {\n    left: 10px;\n}\n\n.nextButton {\n    right: 10px;\n}\n\n    .previousButton:hover,\n    .nextButton:hover {\n        background-color: rgba(0, 0, 0, 0.6);\n    }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `BasePanel-module__container___bwZoT`,
	"backgroundImage": `BasePanel-module__backgroundImage___nODjX`,
	"overlayImage": `BasePanel-module__overlayImage___q1WOS`,
	"overlayVideo": `BasePanel-module__overlayVideo___Z6DAN`,
	"spinner": `BasePanel-module__spinner___WD4OZ`,
	"spin": `BasePanel-module__spin___Kzoz8`,
	"spinnerContainer": `BasePanel-module__spinnerContainer___goIKk`,
	"pdfCanvas": `BasePanel-module__pdfCanvas___O8BtE`,
	"pdfFrame": `BasePanel-module__pdfFrame___xnnmH`,
	"pdfLoading": `BasePanel-module__pdfLoading___zLUO9`,
	"pdfFallback": `BasePanel-module__pdfFallback___a6HVi`,
	"downloadButton": `BasePanel-module__downloadButton___XXHBj`,
	"previousButton": `BasePanel-module__previousButton___KSbFR`,
	"nextButton": `BasePanel-module__nextButton___dk0Eq`
};
export default ___CSS_LOADER_EXPORT___;
